import TypeLabel from './type-label';

export default TypeLabel;
